import {
  put,
  fork,
  call,
  takeEvery,
  all,
  take,
  select,
  delay,
} from 'redux-saga/effects';
import app from '../app';
import {
  payByWechatCompletion,
  payByWalletCompletion,
  loadOrder,
  loadRefund,
} from '../actions';

function* watchPayByWechat() {
  yield takeEvery('PAY_BY_WECHAT', function*({ payModule, id, redirectUrl }) {
    if (app.wechat) {
      try {
        yield call(app.wechat.pay, { payModule, id });

        if (payModule === 1) {
          yield call(afterPayOrder, id);
          yield put(payByWechatCompletion(payModule, id));
          // yield call(gioTrackForOrderPay, 'payOrderSuccess', id, 'wechat');
        } else if (payModule === 2) {
          yield call(afterPayRefund, id);
          yield put(payByWechatCompletion(payModule, id));
        }
      } catch (error) {
        yield put(payByWechatCompletion(payModule, id, error));

        /* if (payModule === 1) {
          yield call(gioTrackForOrderPay, 'payOrderFail', id, 'wechat');
        } */
      }

      return;
    }

    /* MWEB */
    let jumpUrl = '';
    const location = window.location;
    const href = location.origin + location.pathname + location.search;
    const encodedUrl = encodeURIComponent(href + '#' + redirectUrl);

    if (payModule === 1) {
      jumpUrl = `/api/order/${id}/wx/paycode?redirectUrl=${encodedUrl}`;
    } else if (payModule === 2) {
      jumpUrl = `/api/after/${id}/payCode?redirectUrl=${encodedUrl}`;
    }

    window.location.href = jumpUrl;
    yield put(
      payByWechatCompletion(payModule, id, new Error('微信支付跳转中...'))
    );
  });
}

function* watchPayByWallet() {
  yield takeEvery('PAY_BY_WALLET', function*({ payModule, id, payPass }) {
    let options = {};

    if (payModule === 1) {
      options = {
        url: `/api/order/${id}/wallet/pay`,
        method: 'POST',
        data: { orderId: id, password: payPass },
      };
    }
    const result = yield call(app.httpFetch, options);

    if (payModule === 1) {
      if (!result.error) {
        yield call(afterPayOrder, id);
      }
      yield put(payByWalletCompletion(payModule, id, result.error));
      /* const trackType = result.error ? 'payOrderFail' : 'payOrderSuccess';
      yield call(gioTrackForOrderPay, trackType, id, 'wallet'); */
    } else {
      yield put(payByWalletCompletion(payModule, id, result.error));
    }
  });
}

/* function* gioTrackForOrderPay(trackType, orderId, payType) {
  const order = yield select(state => state.mall.order.orders[orderId]);
  const own = yield select(state => state.own.own);
  const trackProductType =
    trackType === 'payOrderSuccess' ? 'payProOrderSuccess' : 'payProOrderFail';

  app.track.trackEvent(trackType, { order, payType, own });
  for (const product of order.orderSkuVos) {
    app.track.trackEvent(trackProductType, {
      order,
      product,
    });
  }
} */
function* afterPayOrder(orderId) {
  const order = yield select(state => state.mall.order.orders[orderId]);
  if (order.orderType === 4) {
    yield delay(200);
  }

  yield put(loadOrder(orderId));
  // const orderResult = yield take('LOAD_ORDER_COMPLETION');
  yield take('LOAD_ORDER_COMPLETION');

  /* if (!orderResult.error) {
    const [order, own] = yield select(state => [
      state.mall.order.orders[orderId],
      state.own.own,
    ]);
    const { orderType, pt, orderSkuVos } = order;

    if (orderType === 4 && pt && pt.users) {
      const { users } = pt;
      let trackGroupType =
        users[0].uid === own.uid ? 'openingGroupSucces' : 'joinTheGroupSucces';
      app.track.trackEvent(trackGroupType, {
        order,
        product: orderSkuVos[0],
        own,
      });
    }
  } */
}

function* afterPayRefund(afterSaleId) {
  app.showTips('succ', '微信支付成功');
  yield put(loadRefund(afterSaleId));
  yield take('LOAD_REFUND_COMPLETION');
}

export default function* paySaga() {
  yield all([fork(watchPayByWechat), fork(watchPayByWallet)]);
}
